/* global appData */

import { mapState } from 'vuex';

// Template and media files
import template from './userbar.vhtml';
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import close from '../../../_img/icons/close.svg';
import $, { parseJSON } from 'jquery';

function doRequest(endpoint, data) {
	return $.ajax({
		method: 'post',
		data: data,
		url: `${appData.root}${endpoint}`,
		headers: { 'X-WP-Nonce': appData.nonce }
	});
}

export default {
	template: template,
	components: {
		vueDropzone: vue2Dropzone,
		vSelect,
		close
	},
	props: {
		userCreate: {
			type: Boolean,
			default: false,
		},
		listId: {
			type: Number,
			default: null
		},
		content: null,
		extraclass: null,
	},
	data() {
		return {
			mailinglist: {
				listings: [],
				categories: []
			},
			inputs: {
				categories: []
			},
			userdata: appData.user,
			isLoggedIn: appData.user.isLoggedIn,
			isOpen: false,
			logOutUrl: appData.user.logout.replace(/&amp;/g, '&'),
			appListings: appData.appListings,
			appCategories: appData.appCategories,
			showInfo: false,
			showPassword: false,
			showSignup: false,
			showCreateCase: false,
			loading: false,
			errored: false,
			success: false,
			caseID: null,
			showSecondary: false,
			dropzoneOptions: {
				url: 'test',
				autoProcessQueue: false,
				maxFilesize: 20,
				params: {},
				previewTemplate: this.template(),
				dictInvalidFileType: 'Filtypen er ikke tilladt og vil ikke blive uploadet',
				maxFiles: 1,
				dictResponseError: 'Filen blev ikke uploaded succesfuldt',
				dictMaxFilesExceeded: 'Du kan ikke uploade flere filer',
				acceptedFiles: 'image/png,image/jpeg,image/gif'
			}
		}
	},
	methods: {
		toggleMenu: function () {
			this.isOpen = this.isOpen != true;
		},
		showInfobox: function () {
			this.showInfo = true
			this.isOpen = false
		},
		showSecondaryForm: function () {
			this.showSecondary = true
		},
		showChangePassword: function () {
			this.showPassword = true
			this.isOpen = false
		},
		showCreateCaseBox: function () {
			this.showCreateCase = true
			this.isOpen = false
		},
		showSignupBox: function () {
			this.showSignup = true
			this.isOpen = false
		},
		hideSlideIn: function () {
			this.showPassword = false
			this.showInfo = false
			this.showCreateCase = false
			this.showSignup = false
			this.loading = false
			this.success = false
			this.errored = false
			this.failed = false
			this.caseID = null,
				this.mailinglist = {
					listings: [],
					categories: []
				},
				this.inputs = {
					categories: []
				}
			this.userdata.password = ''
			this.userdata.passwordrepeat = ''
		},
		handlePasswordUpdate: function () {
			this.loading = true
			this.errored = false
			this.failed = false

			if (this.userdata.password !== this.userdata.passwordrepeat) {
				this.loading = false
				this.errored = true
				this.errormessage = 'De indtastede passwords matcher ikke'
				return ''
			}

			if (!this.userdata.password) {
				this.loading = false
				this.errored = true
				this.errormessage = 'Der er ikke indtastet et password. Prøv venligst igen.'
				return ''
			}

			//Make a request to WP
			let data = {
				password: this.userdata.password,
				passwordrepeat: this.userdata.passwordrepeat,
				username: this.userdata.username,
				id: this.userdata.id,
			}
			doRequest('kla/v1/user/changepassword', data)
				.done(data => {
					this.loading = false

					if (typeof data.nonce !== 'undefined') {
						appData.nonce = data.nonce
					}

					if (data.updated) {
						this.success = true
						this.failed = false
						this.userdata.password = ''
						this.userdata.passwordrepeat = ''
						appData.user.isLoggedIn = true
					}

					if (!data.updated) {
						this.errored = true
						this.errormessage = 'Der skete en fejl under forsøget på at opdatere din adgagnskode. Prøv venligst igen.'
					}


				})
				.fail(data => {
					this.loading = false
					this.errored = true
					this.errormessage = 'Der skete en fejl under forsøget på at opdatere din adgagnskode. Prøv venligst igen.'
				});


		},
		handleUserUpdate: function () {
			this.loading = true
			this.errored = false
			this.failed = false

			//Make a request to WP
			let data = {
				name: this.userdata.name,
				id: this.userdata.id,
				company: this.userdata.company,
				phone: this.userdata.phone,
				email: this.userdata.email,
				username: this.userdata.username,
				listings: this.userdata.listings,
				categories: this.userdata.categories
			}

			doRequest('kla/v1/user/update', data)
				.done(data => {
					this.loading = false

					if (data.updated) {
						this.success = true
						this.failed = false
					}

					if (!data.updated) {
						this.errored = true
						this.errormessage = data.errormessage
					}


				})
				.fail(data => {
					this.loading = false
					this.errored = true
				});
		},
		handleMailingSignup: function () {
			this.loading = true
			this.errored = false
			this.failed = false

			//Make a request to WP
			let data = {
				name: this.mailinglist.name,
				email: this.mailinglist.email,
				listings: this.mailinglist.listings,
				categories: this.mailinglist.categories
			}

			doRequest('kla/v1/mailinglist/signup', data)
				.done(data => {
					this.loading = false

					if (data.created) {
						this.success = true
						this.failed = false
					}

					if (!data.created) {
						this.errored = true
						this.errormessage = data.errormessage
					}


				})
				.fail(data => {
					this.loading = false
					this.errored = true
				});
		},
		handleCreateUserCase: function () {
			this.loading = true
			this.errored = false
			this.failed = false

			//Create usercase
			let data = {
				listing: this.listId,
				data: this.inputs
			}
			doRequest('kla/v1/user-listing/create', data)
				.done(data => {

					if (data.created) {
						this.caseID = data.caseID
						this.uploadCaseHeader()
					}

					if (!data.created) {
						this.loading = false
						this.errored = true
						this.errormessage = data.errormessage
					}

				})
				.fail(data => {
					this.loading = false
					this.errored = true
				});

			//Upload files
		},
		uploadCaseHeader: function () {
			//Upload files to unique location
			this.$refs.createformDropzone.setOption('url', appData.root + 'kla/v1/user-listing/upload/')
			this.$refs.createformDropzone.setOption('params', { caseID: this.caseID })
			this.$refs.createformDropzone.processQueue()

			this.loading = false
			this.success = true
		},
		sendingEvent(file, xhr, formData) {

		},

		fileError(file, message, xhr) {
			if (xhr) {
				this.errored = true
			}
		},

		fileCompleted(file, response) {
			if (!response.status) {
				this.errored = true;
			}
		},

		pendingFiles() {
			let status = false
			var i;
			for (i = 0; i < this.$refs.createformDropzone.length; i++) {
				if (this.$refs.createformDropzone[i].getAcceptedFiles().length) {
					status = true;
					break;
				}
			}
			return status
		},

		allFilesUploaded() {
			let status = true
			var i;
			for (i = 0; i < this.$refs.createformDropzone.length; i++) {
				if (this.$refs.createformDropzone[i].getUploadingFiles().length) {
					status = false;
					break;
				}
			}
			return status
		},

		queCompleted() {
			let allComplete = true

			if (this.loading && this.allFilesUploaded()) {
				this.formCompleted()
			}
		},
		formCompleted() {
			if (!this.isErrored) {
				//If success
				this.loading = false
				this.success = true
				this.failed = false
			}
		},
		template: function () {
			return `<div class="dz-preview dz-file-preview">
						<div class="dz-details">
							<div class="dz-filename"><span data-dz-name></span></div>
							<div class="dz-size"><span data-dz-size></span></div>
						</div>
						<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
						<div class="dz-error-message"><span data-dz-errormessage></span></div>
						<div class="dz-success-mark"><i class="fa fa-check"></i></div>
						<div class="dz-error-mark"><i class="fa fa-close"></i></div>
						<a class="dz-remove" data-dz-remove><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash-alt fa-w-14 fa-3x"><path fill="currentColor" d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z" class=""></path></svg></a>
					</div>
			`;
		}
	},
	computed: {
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/userbar/userbar.js